import script from "./ExperimentaisMatriculas.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperimentaisMatriculas.vue?vue&type=script&setup=true&lang=js"

import "./ExperimentaisMatriculas.vue?vue&type=style&index=0&id=bdae4288&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdae4288"]])

export default __exports__